export enum WinningProposalOptionValues {
  YES = 'yes',
  NO_RESUBMIT_FOR_REVIEW = 'no - Resubmit for review',
  NO_OPPORTUNITY_LOST_DISCONTINUE_ABANDONED = 'no - opportunity lost, discontinued or abandoned',
}
